<template>
    <div id="app" :class="vueAppClasses">
        <router-view @setAppClasses="setAppClasses"/>
    </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import getUseServer from '@/utils/getServer'

export default {
    metaInfo: {
        title: 'NETWORK',
        link: [{ rel: 'icon', href: `favicon.ico`}]
    },

    data() {
        return {
            vueAppClasses: [],
        }
    },

    computed: {
        error() {
            return this.$store.getters.error.error
        },

        success() {
            return this.$store.getters.success.success
        },

        loader() {
            return this.$store.getters.loader
        },

        authError() {
            return this.$store.getters.authError
        }
    },

    watch: {
        '$store.state.theme'(val) {
            this.toggleClassInBody(val)
        },
        '$vs.rtl'(val) {
            document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
        },

        loader() {
            if (this.$store.getters.loader) {
                this.$Progress.start()
            } else {
                this.$Progress.finish()
            }
        },

        error(val) {
            if (val) {
                const icon = this.$iconData('icon-error', 'fi-rr-exclamation')
                const error = this.$store.getters.error
                if (error.message.server) {
                    this.$ns.notify({
                        title: error.message.server ? `Error! - ${error.message.server}` : 'Error!',
                        text: error.message.error ? error.message.error : error.message,
                        color: 'danger',
                        iconPack: icon['icon-pack'],
                        icon: icon.icon
                    })
                }
                this.$store.dispatch('CLEAR_ERROR')
                this.$Progress.fail()
            }
        },

        success() {
            if (this.$store.getters.success.success) {
                const icon = this.$iconData('icon-check', 'fi-rr-check')
                this.$vs.notify({
                    title: 'Success!',
                    text: this.$store.getters.success.message,
                    color: 'success',
                    iconPack: icon['icon-pack'],
                    icon: icon.icon
                })
            }
            this.$store.dispatch('CLEAR_SUCCESS')
        },

        '$store.getters.perm_error'(val) {
            const home = this.$route.path
            if (val.perm_error && home !== '/home') {
                const icon = this.$iconData('icon-error', 'fi-rr-exclamation')
                this.$router.push('/home')
                this.$vs.notify({
                    title: 'Permission error!',
                    text: this.$store.getters.perm_error.message,
                    color: 'warning',
                    iconPack: icon['icon-pack'],
                    icon: icon.icon
                })
            }
            this.$store.dispatch('PERM_CLEAR')
        }
    },
    methods: {
        toggleClassInBody(className) {
            if (className === 'dark') {
                if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
                document.body.classList.add('theme-dark')
            } else if (className === 'semi-dark') {
                if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
                document.body.classList.add('theme-semi-dark')
            } else {
                if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
                if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
            }
        },
        setAppClasses(classesStr) {
            this.vueAppClasses.push(classesStr)
        },
        handleWindowResize() {
            this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

            // Set --vh property
            document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
        },
        handleScroll() {
            this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
        },
    },
    mounted() {
        const server = getUseServer()

        const token = localStorage.getItem(server.name)
        if (token && !this.$store.getters.token) {
            this.$store.dispatch('SET_TOKEN', token)
        }

        if (this.$store.getters.authError && !token) {
            this.$router.push('/login')
        }

        this.toggleClassInBody(themeConfig.theme)
        this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

        const vh = window.innerHeight * 0.01
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`)
    },
    async created() {
        //Add class to body -> brand
        this.$store.commit('setBrand', process.env.VUE_APP_BRAND)

        this.$store.commit('SET_TEAMS_AUTOLOGIN', process.env.VUE_APP_IS_AUTOLOGIN !== 'false')

        const brand = process.env.VUE_APP_BRAND
        if (brand) {
            document.body.classList.add(`network-${brand}`)
        }
        ///

        const dir = this.$vs.rtl ? 'rtl' : 'ltr'
        document.documentElement.setAttribute('dir', dir)

        window.addEventListener('resize', this.handleWindowResize)
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed() {
        window.removeEventListener('resize', this.handleWindowResize)
        window.removeEventListener('scroll', this.handleScroll)
    }
}

</script>

<style lang="scss">
.v-select.vs--single {
    .vs__selected-options {
        width: 0;
        .vs__selected {
            width: calc(100% - 20px);
            overflow: hidden;
        }
    }
}

.flag.size-m {
    width: 25px !important;
    height: 17px !important;
}

.filter input::placeholder,
.server-filter input::placeholder {
    position: absolute;
    border-radius: 5px;
    padding: 0.4rem;
    padding-left: 0 !important;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    font-size: .85rem;
    color: rgba(0,0,0,.4);
    white-space: nowrap;
    cursor: text;
    user-select: none;
    top: -1px;
    pointer-events: none;
}

.vs__dropdown-option--selected {
    display: none !important;
}

.vs-select--options {
    z-index: 9999999999;
}

/*.vs-input--icon {*/
/*    font-size: 1.5rem;*/
/*    left: 10px;*/
/*}*/
.vs-input .vs-con-input input.vs-input--input.hasIcon:not(.icon-after-input):-webkit-autofill + span {
    transform: translate(-3px, -90%) !important;
    padding-left: 0.7rem !important;
    font-size: .7rem;
}

.vs-input--input.hasValue.hasIcon:not(.icon-after-input) + .vs-placeholder-label {
    padding-left: 0.7rem !important;
}

/* Loader inside switch to be visible */
button .con-vs-loading {
    position: relative;
}
</style>
